module.exports = __webpack_public_path__ + "2c1b47ded768e6ad3818ff5d22998e67.png";